'use client';

import {useBEApiClient} from '@hooks/network/useApiClient';
import type {PropsWithChildren} from 'react';
import {useEffect, useRef} from 'react';
import useSWRImmutable from 'swr/immutable';

import {McpManifestsContext, createMcpManifestsStore} from './store';

export const McpManifestsProvider = (props: PropsWithChildren) => {
  const {children} = props;
  const api = useBEApiClient();

  const {data: {data: manifests} = {}, isLoading} = useSWRImmutable(
    'mcp-manifests',
    () => api?.publicListMcpManifests({limit: 400}),
    {
      errorRetryCount: 10,
      keepPreviousData: true,
      revalidateOnReconnect: true,
    },
  );

  const storeRef = useRef<ReturnType<typeof createMcpManifestsStore> | null>(createMcpManifestsStore());

  useEffect(() => {
    if (manifests && !isLoading) {
      storeRef.current?.getState().setManifests(manifests.items);
    }
  }, [manifests, isLoading]);

  useEffect(() => {
    storeRef.current?.getState().setIsManifestsLoading(isLoading);
  }, [isLoading]);

  return <McpManifestsContext.Provider value={storeRef.current}>{children}</McpManifestsContext.Provider>;
};
